import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseQueryParamService } from '../../services/base-query-param.service';

@Component({
  selector: 'base-pagination',
  templateUrl: './base-pagination.component.html',
})
export class BasePaginationComponent {
  @Input() page = 1;
  @Input() itemsCount = 0;
  @Input() size = 15;
  @Input() visiblePages = 5;
  @Input() noFilters = false;

  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  constructor(private queryParamsService: BaseQueryParamService) {}

  onPageChange(page: number): void {
    this.page = page;
    if (!this.noFilters) {
      this.updateFilterSubject();
    } else {
      this.pageChange.emit(this.page);
    }
  }

  private updateFilterSubject(): void {
    this.queryParamsService.filterSubject.next({
      page: this.page,
    });
  }
}
